import type { AgentActionCard } from "../lists/types";

const STATE_LABEL: Record<AgentActionCard["state"], string> = {
  pending: "czeka na decyzję",
  done: "wykonane",
  rejected: "odrzucone",
  reverted: "cofnięte",
};

interface Props {
  card: AgentActionCard;
  busy?: boolean;
  onConfirm: (id: string) => void;
  onReject: (id: string) => void;
  onUndo: (id: string) => void;
}

/** Karta propozycji agenta: [Zatwierdź] [Odrzuć], a po wykonaniu [Cofnij]. */
export function ActionCard({ card, busy, onConfirm, onReject, onUndo }: Props) {
  const entries = Object.entries(card.args ?? {});

  return (
    <div className={`action action--${card.state}`}>
      <div className="action__head">
        <span className="action__tool">{card.tool}</span>
        <span className="action__state">{STATE_LABEL[card.state]}</span>
      </div>

      <p className="action__desc">{card.description}</p>

      {entries.length > 0 && (
        <dl className="action__args">
          {entries.map(([key, value]) => (
            <div key={key} className="action__arg">
              <dt>{key}</dt>
              <dd>{String(value)}</dd>
            </div>
          ))}
        </dl>
      )}

      {card.error && <p className="action__error">{card.error}</p>}
      {card.notice && <p className="action__notice">{card.notice}</p>}

      <div className="action__buttons">
        {card.state === "pending" && (
          <>
            <button className="btn btn--primary" disabled={busy} onClick={() => onConfirm(card.id)}>
              Zatwierdź
            </button>
            <button className="btn" disabled={busy} onClick={() => onReject(card.id)}>
              Odrzuć
            </button>
          </>
        )}
        {card.undoable && (
          <button className="btn" disabled={busy} onClick={() => onUndo(card.id)}>
            Cofnij
          </button>
        )}
      </div>
    </div>
  );
}
